import { useState } from 'react';
import { useRouter } from 'next/compat/router';
import {
  AUTHENTICATION_PATH,
  QUALIFIED_MEMBER_LOGIN_PATH,
  UNAUTHORIZED_PATH,
} from '@pass-frontend/common/constants/paths';
import { useCurrentUserData } from '@pass-frontend/common/data-bridge';
import { LWR_AUTH } from '@pass-frontend/features/authentication/util';
import { env } from '@pass-frontend/features/configuration/util';
import { eventBus, useWhileMounted } from '@pass-frontend/utility/event-bus';
import { useStableCallback } from '@pass-frontend/utility/swiss-knife';

import { HUGINN_LOAD } from './huginn-helpers';

// These listeners in the 'React-free' zone will not be
// unsubscribed on unmount, or run twice in strict mode.
import './listeners';

const HUGINN_ENABLED = env().ENABLE_LWR;

export const useLWR = () => {
  const [isHuginnAuthenticated, setIsHuginnAuthenticated] = useState(false);
  const { query, push, pathname } = useRouter();
  const { isQualifiedUser } = useCurrentUserData();

  const isQualifiedMemberExperience =
    pathname === QUALIFIED_MEMBER_LOGIN_PATH || isQualifiedUser;

  const isUnauthPage = pathname === UNAUTHORIZED_PATH;

  const isLoginPending =
    HUGINN_ENABLED &&
    !(isHuginnAuthenticated || isQualifiedMemberExperience || isUnauthPage);

  // If on the auth page, send them to the correct page (otherwise we just remove the spinner)
  useWhileMounted(() =>
    eventBus.listen(LWR_AUTH.complete.match, () => {
      setIsHuginnAuthenticated(true);

      // In this login with Rally user flow, redirecting to base path post authentication
      // anyway this is going to be decommissioned soon and currently we are showing a pop up to get user registered with HSID
      const newUrl = '/';
      if (pathname === AUTHENTICATION_PATH) {
        push(newUrl);
      }
    }),
  );

  const requestAuth = useStableCallback(() => {
    eventBus.trigger(HUGINN_LOAD.request());
  });

  return {
    HUGINN_ENABLED,
    requestAuth,
    isHuginnAuthenticated,
    isLoginPending,
  };
};
